import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img1 from "../../images/solution/wearable/smartphone-2.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Link} from 'gatsby';

const Smartphone = () => {
  return (
    <div className="smartphone p-100" style={{ backgroundColor: "#F6F6F6" }}>
         <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5} >
                        <h2>Don’t Limit Yourself To Just a Smartphone When Reaching Out To Customers</h2>
                        <p>It’s a brave new world, filled with exciting opportunities. It’s the time to experiment and conquer new realms as a company. Your customers are now everywhere. They use their wearable devices as much as they use their smartphones, so don’t miss out on this incredible opportunity to be with them always.</p>
                        <p>Tekrevol is the perfect wearable app development company you can onboard for your project and build a better tomorrow for your business.</p>
                        <Link to="/contact"
                                  className="border_btn" aria-label="TekRevol Contact"> Get a Free Estimation Today</Link>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="offset-xl-2">
                    <LazyLoadImage
                            src={Img1}
                            effect="blur" alt="TekRevol" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Smartphone